module.exports = __webpack_public_path__ + "static/media/IRANSansWeb(FaNum).a1233cc1.woff";